import { createBrowserRouter, Navigate } from 'react-router-dom'
import TestPage from '@pages/TestPage.jsx'
import { Bridge } from '@pages/Bridge.jsx'
import { ErrorPage } from '@pages/ErrorPage.jsx'
import { AppInit } from '@routes/AppInit.jsx'
import { AppDataLoader } from '@routes/AppDataLoader.jsx'
import RootErrorBoundary from '@components/common/RootErrorBoundary.jsx'
import { widgetRoutes } from '../widgets/routes/widgetRoutes'
import targetRoutes from '@targetRoutes'

const routesConfig = [
  {
    path: '/',
    element: <RootErrorBoundary />,
    errorElement: <ErrorPage />,

    children: [
      {
        path: 'test-auth',
        element: <TestPage />
      },
      {
        path: 'bridge',
        element: <Bridge />
      },
      {
        path: '',
        element: <AppInit />,
        children: [
          {
            path: '',
            element: <AppDataLoader />,
            children: [
              ...widgetRoutes,
              { index: true, element: <Navigate to="/main" replace /> },
              ...targetRoutes
            ]
          }
        ]
      }
    ]
  }
]

const router = createBrowserRouter(routesConfig)

export default router
